/** One label for the full /trips* cold-load path (inline splash + React fallbacks). */
export const TRIP_LAUNCH_LOADING_LABEL = 'Loading your trip…';

export function isTripLaunchPath(pathname: string): boolean {
  return pathname === '/trips' || pathname.startsWith('/trips/');
}

export function tripLaunchLoadingLabel(pathname: string): string {
  return isTripLaunchPath(pathname) ? TRIP_LAUNCH_LOADING_LABEL : 'Loading…';
}
